import { Injectable } from '@angular/core';
import { NavigationError, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';

@UntilDestroy()
@Injectable()
export class CmRouterErrorService {
	constructor(private readonly router: Router) {
		this.router.events
			.pipe(
				untilDestroyed(this),
				filter(event => event instanceof NavigationError)
			)
			.subscribe(event => {
				const err = new Error('Angular Router Error');
				throw {
					...err,
					...event,
				};
			});
	}
}
